<template>
  <form class="flex flex-col space-y-6"
        @submit.prevent="submit">
    <div class="space-y-1">
      <inputs-label for="email_address" title="Email Address"/>

      <inputs-email :required="true" for="email_address" placeholder="joe@doe.com"
                    @set="email_address = $event.target.value"/>
    </div>

    <button :class="disable_button ? 'btn-primary-disabled-md' : 'btn-primary-md'" :disabled="disable_button"
            class="w-full"
            type="submit">
      Request new password
    </button>
  </form>
</template>

<script setup>
const router = useRouter()
const {$global, $bus} = useNuxtApp()

const disable_button = ref(false)
const email_address = ref(null)

function submit() {
  disable_button.value = true

  $fetch(`${$global.api_url}/forgot/password/${email_address.value}`, {
    method: 'POST',
  })
      .then((response) => {
        $bus.$emit('flash', {
          type: 'success',
          title: `Password reset email sent to ${email_address.value}.`,
          timeout: 10000,
        })

        router.push('/login')
      })
      .catch((error) => {
        disable_button.value = false

        $bus.$emit('flash', {
          type: 'error',
          title: error.message,
          timeout: 10000,
        })
      })
}
</script>
